import React from 'react';

const Notification = ({ onClick, text, info = false, buttonText }) => {
    return (
        <div
            className={
                info ? 'notification notification--info' : 'notification'
            }
        >
            <div
                className={
                    info
                        ? 'notification__content notification__content--info'
                        : 'notification__content'
                }
            >
                <div className="notification__details">
                    <span
                        className={
                            info
                                ? 'notification__icon--info'
                                : 'notification__icon--error'
                        }
                    ></span>
                    <p className="notification__text">{text}</p>
                </div>
                {buttonText && (
                    <button
                        type="button"
                        className="button notification__button"
                        onClick={() => onClick()}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};
export default Notification;
